require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./radio"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./radio"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./radio")) : factory(root["./utils"], root["./radio"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__84__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[48],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(436);


/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _RadioGroup = _interopRequireDefault(__webpack_require__(437));

exports["default"] = _RadioGroup["default"];
exports.RadioGroup = _RadioGroup["default"];

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _radio = __webpack_require__(84);

var _baUiCarbon = __webpack_require__(12);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-common
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var BaPropTypes = _utils.propsUtils.BaPropTypes;

var RadioGroup = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(RadioGroup, _Component);

  function RadioGroup() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = RadioGroup.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        labelPosition = _this$props.labelPosition,
        orientation = _this$props.orientation,
        valueSelected = _this$props.valueSelected,
        children = _this$props.children,
        align = _this$props.align,
        checked = _this$props.checked,
        direction = _this$props.direction,
        options = _this$props.options,
        readOnly = _this$props.readOnly,
        selectedId = _this$props.selectedId,
        otherRadioButtonGroupProps = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["labelPosition", "orientation", "valueSelected", "children", "align", "checked", "direction", "options", "readOnly", "selectedId"]);
    var mappedLabelPosition = labelPosition != null ? labelPosition : align === 'right' ? 'left' : undefined;
    var mappedOrientation = orientation != null ? orientation : direction;
    var mappedValueSelected = valueSelected != null ? valueSelected : checked;
    var mappedChildren = children != null ? children : options.map(function (props) {
      return (0, _radio.renderCarbonRadioButton)(props);
    });
    return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.RadioButtonGroup, (0, _extends2["default"])({}, otherRadioButtonGroupProps, {
      labelPosition: mappedLabelPosition,
      orientation: mappedOrientation,
      valueSelected: mappedValueSelected
    }), mappedChildren);
  };

  return RadioGroup;
}(_react.Component);

exports["default"] = RadioGroup;
(0, _defineProperty2["default"])(RadioGroup, "propTypes", (0, _extends2["default"])({}, _baUiCarbon.RadioButtonGroup.propTypes, {
  /** Provide a collection of <RadioButton> components to render in the group */
  children: _propTypes["default"].arrayOf(_propTypes["default"].shape((0, _extends2["default"])({}, _baUiCarbon.RadioButton.propTypes))).isRequired,

  /** deprecated - use labelPosition */
  align: BaPropTypes.deprecated('deprecated - use labelPosition'),

  /** deprecated - use valueSelected */
  checked: BaPropTypes.deprecated('deprecated - use valueSelected'),

  /** deprecated - use orientation */
  direction: BaPropTypes.deprecated('deprecated - use orientation'),

  /** deprecated - pass RadioButton options as children of RadioButtonGroup */
  options: BaPropTypes.deprecated('deprecated - pass RadioButton options as children of RadioButtonGroup'),

  /** deprecated - no Carbon option(maybe disabled) */
  readOnly: BaPropTypes.deprecated('deprecated - no Carbon option(maybe disabled)'),

  /** deprecated - no Carbon option */
  selectedId: BaPropTypes.deprecated('deprecated - no Carbon option')
}));

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 84:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__84__;

/***/ })

},[[435,0]]]);
});